// 지도관제 중에서도 지도 영역에 대한 부분 관련. 마커등등..
import { mapControl } from '@/constants';
import { getGlobalStore } from '@/lib/global-store';
import { MapWorker } from '@/lib/map-control/model';
import mapMarkerList from '@/lib/map-control/mapMarkerList';
import Bounds from './Bounds';
import { isIncludedCurrentFilter, isShowSomeDropMarker, } from './helper';
const vuexStore = getGlobalStore();
// 마커 제어 구분
// 생성 : add  => 초기화, 주문 추가
// 활성 : active => 클릭시
// 연관 : weight > 0 => 연관 상태
// 숨김 : clear => 필터등으로 일시 숨김
// 제거 : clear true => 완료시
// 적용 순서
// vuex 상태 기반으로 랜더링 되도록 제작
// 추가시 vuex -> map
const defaultMapId = 'map';
export default class HubControlMap {
    // eslint-disable-next-line no-use-before-define
    static instance = null;
    OUTSIDE;
    ORIGIN;
    FORCE_EMIT;
    mapId;
    options;
    markerCreator;
    fitBoundsMaxZoom;
    homeBtnFitBoundsMargin;
    selectedStoreId;
    orderFilter;
    workerFilter;
    homeBtnHtml;
    workerClickCallback;
    dropClickCallback;
    lineMouseEnterCallback;
    lineMouseLeaveCallback;
    homeBtnFitBoundsMaxZoom;
    static getInstance(mapId = defaultMapId, options = {}) {
        if (HubControlMap.instance == null) {
            HubControlMap.instance = new HubControlMap(mapId, options);
        }
        return this.instance;
    }
    mapControlState = null;
    mapMarkerList = null;
    naver = null;
    mapInstance = null;
    bounds = null;
    constructor(mapId, options = {}) {
        this.OUTSIDE = mapControl.mapBoundary.OUTSIDE;
        this.ORIGIN = mapControl.mapBoundary.ORIGIN;
        this.FORCE_EMIT = {
            ON: true,
            OFF: false,
        };
        this.mapId = mapId;
        this.options = options;
        this.markerCreator = null;
        // this.bounds = null;
        // this.fitBoundsMaxZoom = 15;
        this.homeBtnFitBoundsMargin = 20;
        this.fitBoundsMaxZoom = 18;
        /** 마커 관리 */
        this.mapMarkerList = mapMarkerList;
        /** 선택된 상점 (vuex와 sync) */
        this.selectedStoreId = null;
        /** 선택된 주문 필터 */
        this.orderFilter = [];
        /** 선택된 워커 필터 */
        this.workerFilter = [];
        /** 홈버튼 */
        this.homeBtnHtml = `<div style="text-align:center">
    <span title="한눈에 보기" style="cursor:pointer; display:inline-block;background:#fff;
    border:1px solid #000;border-radius:5px;width:30px;height:30px">
    <img style="margin-top:5px" src="/svg/flag.svg" />
    </span></div>`;
        this.workerClickCallback = () => { };
        this.workerClickCallback = () => { };
        this.dropClickCallback = () => { };
        this.lineMouseEnterCallback = () => { };
        this.lineMouseLeaveCallback = () => { };
    }
    /**
     * 맵 사이즈를 변경합니다.
     * @param _width
     * @param _height
     */
    setMapSize(_width, _height) {
        const { width, height } = this.mapInstance.getSize();
        this.mapInstance.setSize({
            width: _width || width,
            height: _height || height,
        });
    }
    /**
     * 주문 필터 설정
     * @param filterList 필터 리스트
     */
    setOrderFilter(filterList = [
        mapControl.orderStatusGroupList.ALL.code,
    ]) {
        this.orderFilter = filterList;
    }
    /**
     * 워커 필터 설정
     * @param filterList 필터목록
     */
    setWorkerFilter(filterList = [
        mapControl.mapControlAttendCode.ALL.code,
    ]) {
        this.workerFilter = filterList;
    }
    /**
     * 지도 옵션 셋팅
     * @param options 지도 옵션 셋팅
     */
    setMapOptions(options = {}) {
        this.mapInstance.setOptions(options);
    }
    setSelectedStoreId(storeId) {
        this.selectedStoreId = storeId;
    }
    /**
     * 주문 비노출
     * 주문 배차 라이더 연관 상태 해제
     * 연관 스토어 해제
     * @param orderItems 주문 데이터 객체 또는 배열
     * @returns
     */
    clearAllDropMarker(orderItems = {}) {
        Object.values(orderItems)
            .forEach(({ orderId }) => {
            const mkDrop = this.mapMarkerList.drops.getMarker(orderId);
            mkDrop?.deactivateMarker();
        });
    }
    /**
     * 워커 마커 상태 초기화 복수개 + 마커 제거
     * @param isDeleteMarker 마커 제거 여부
     */
    clearAllWorkerMarker(isDeleteMarker) {
        Object.values(this.mapMarkerList.workers.items)
            .forEach(({ id }) => {
            const mkWorker = this.mapMarkerList.workers.getMarker(id);
            mkWorker.deactivateMarker(isDeleteMarker);
        });
    }
    /**
     * 전체 상점 초기화
     * @param isDeleteMarker 지도에서 마커 제거 여부 (주문 포함)
     */
    clearAllStoreMarker(isDeleteMarker) {
        Object.values(this.mapMarkerList.stores.items).forEach(({ id }) => {
            const mkStore = this.mapMarkerList.stores.getMarker(id);
            mkStore.deactivateMarker(isDeleteMarker);
        });
    }
    /**
     * 네이버 지도 idle 이벤트
     */
    onIdle() {
        const { mapInstance, } = this;
        const { workers, stores, drops, } = this.mapMarkerList;
        const { isHideShareOrder, isHideStoreMarker, } = this.mapControlState.mapVisibilitySetting;
        // 워커 관련 로직
        Object.values(workers.items).forEach((mkWorker) => {
            const isShow = mkWorker.computeIsShow();
            mkWorker.toggleVisibility(isShow ? mapInstance : null);
        });
        // 스토어 관련 로직
        Object.values(stores.items).forEach((mkStore) => {
            const storePosition = mkStore.getPosition();
            const isIncludedBoundary = this.bounds.hasBounds(storePosition, this.OUTSIDE);
            const storeData = this.mapControlState.storeList[mkStore.id];
            const orders = storeData.items;
            // 상점마커 노출 설정시에만 상점마커 노출 여부 확인
            // 화면영역에 있다면
            if (!isHideStoreMarker && isIncludedBoundary) {
                const filteredOrder = Object.values(orders)
                    // 필터 채크
                    .filter(({ statusCode }) => isIncludedCurrentFilter(statusCode, this.orderFilter))
                    // 공유접수상태 채크
                    .filter(({ isShareOrder, isAccepted }) => {
                    if (isShareOrder && isHideShareOrder && isAccepted) {
                        return false;
                    }
                    return true;
                });
                if (filteredOrder.length > 0) {
                    mkStore.toggleVisibility(mapInstance);
                    return;
                }
            }
            // bounds 안에 도착지 없으면 노출
            if (isShowSomeDropMarker(storeData, drops, this.bounds.getBounds(this.OUTSIDE))) {
                return;
            }
            // 최종적으로 상점 + 도착지 모두 숨김
            mkStore.toggleVisibilityWithStoreOrder();
        });
    }
    /**
     * 모든 주문 및 라이더 경도, 위도
     * @param state
     * @returns {Array}
     */
    getAllOrdersAndWorkersPosition() {
        const { orderList, workerList } = this.mapControlState;
        return [
            orderList,
            workerList,
        ].reduce((acc, targets) => {
            if (!targets || !Object.keys(targets).length) {
                return acc;
            }
            return Object.values(targets).reduce((acc2, target) => {
                if (target instanceof MapWorker) {
                    acc2.push({
                        lat: target.location.latitude,
                        lng: target.location.longitude,
                    });
                }
                else {
                    acc2.push({
                        lat: target.dropLatitude,
                        lng: target.dropLongitude,
                    });
                }
                return acc2;
            }, acc);
        }, []);
    }
    /**
     * 지도 위치 최적화
     * @param positions
     * @param boundaryType 경계 타입. 반응 기준
     * @param forceEmit 항상 실행 트리거
     * @param _fitBoundsOptions fitbounds options
     */
    optimizePosition(positions, boundaryType, 
    // eslint-disable-next-line
    forceEmit = this.FORCE_EMIT.OFF, _fitBoundsOptions = {}) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const fitBoundsOptions = {
            maxZoom: this.fitBoundsMaxZoom,
            ..._fitBoundsOptions,
        };
        // eslint-disable-next-line
        const allItemIsInside = () => !positions.some((item) => !this.bounds.hasBounds(new this.naver.maps.LatLng(item.lat, item.lng), boundaryType));
        // 0건일 경우 x
        if (!positions.length) {
            return;
        }
        if (allItemIsInside()) {
            return;
        }
        // const value = 100;
        // 단건 (운행건 없는 라이더. 주문의 경우 상점 위치가 있기 때문에 단건 케이스 불가)
        if (positions.length === 1) {
            const center = new this.naver.maps.LatLng(positions[0].lat, positions[0].lng);
            // https://github.com/barogo/zoo/issues/3090#issuecomment-1138476222
            // !this.bounds.hasBounds(center, boundaryType)
            //   && this.map.setCenter(center);
            // 애니메이션 O
            // this.mapInstance.panTo(center);
            // 애니메이션 X
            this.mapInstance.setCenter(center);
            return;
        }
        // 복수건
        if (positions.length > 1) {
            // https://github.com/barogo/zoo/issues/3090#issuecomment-1138476222
            // if (!forceEmit && allItemIsInside()) {
            // if (allItemIsInside()) {
            //   return;
            // }
            const pos = positions.map(({ lat, lng }) => new this.naver.maps.LatLng(lat, lng));
            const bounds = this.naver.maps.LatLngBounds.bounds(...pos);
            this.mapInstance.fitBounds(bounds, fitBoundsOptions);
            // this.mapInstance.panToBounds(bounds, {}, {
            // //maxZoom: this.fitBoundsMaxZoom,
            //   top: value,
            //   left: value,
            //   bottom: value,
            //   right: value,
            // });
        }
    }
    /**
     * 홈버튼 셋팅
     */
    initHomeBtn() {
        const fitBoundsOptions = {
            top: this.homeBtnFitBoundsMargin,
            left: this.homeBtnFitBoundsMargin,
            bottom: this.homeBtnFitBoundsMargin,
            right: this.homeBtnFitBoundsMargin,
            maxZoom: this.homeBtnFitBoundsMaxZoom,
        };
        const customControl = new this.naver.maps.CustomControl(this.homeBtnHtml, {
            position: this.naver.maps.Position.RIGHT_BOTTOM,
        });
        this.naver.maps.Event.once(this.mapInstance, 'init', () => {
            customControl.setMap(this.mapInstance);
        });
        this.naver.maps.Event.addDOMListener(customControl.getElement(), 'click', () => {
            this.optimizePosition(this.getAllOrdersAndWorkersPosition(), this.ORIGIN, this.FORCE_EMIT.ON, fitBoundsOptions);
        });
    }
    /**
     * 초기화
     */
    init() {
        if (!document.querySelector(`#${defaultMapId}`)) {
            return;
        }
        const { hubLatLng: [lat, lng,] } = this.options;
        this.naver = window.naver;
        this.mapInstance = new this.naver.maps.Map(this.mapId, {
            center: new this.naver.maps.LatLng(lat, lng),
            ...this.options,
        });
        this.bounds = Bounds.getInstance(this.naver, this.mapInstance);
        this.bounds.updateBounds();
        this.mapMarkerList.setOptions(this.naver, this);
        this.setOrderFilter([
            mapControl.orderStatusGroupList.ALL.code,
        ]);
        this.setWorkerFilter();
        this.mapControlState = vuexStore.state.mapControl;
        this.initHomeBtn();
    }
    // TODO: 디버깅용
    debugPrintmapMarkerList(type) {
        if (type) {
            // eslint-disable-next-line
            console.log('mapMarkerList: ', this.mapMarkerList[type]);
        }
        else {
            // eslint-disable-next-line
            console.log('mapMarkerList: ', this.mapMarkerList);
        }
        // eslint-disable-next-line
        console.log('selectedStoreId: ', this.selectedStoreId);
        return this;
    }
    // TODO: 디버깅용
    // 최적화 공간 표시 기능
    // 개발자도구 콘솔에 window.hubControlMap.debugTestDrawBounds() 실행 가능
    debugTestDrawBounds(type = mapControl.mapBoundary.ORIGIN) {
        const newBounds = this.bounds.getBounds(type);
        const rect = new this.naver.maps.Rectangle({
            strokeOpacity: 0,
            strokeWeight: 0,
            fillOpacity: 0.2,
            fillColor: '#f00',
            bounds: newBounds,
            map: this.mapInstance,
        });
        setTimeout(() => {
            rect.setMap(null);
        }, 3000);
    }
}
